import styled, { css } from 'styled-components';
import Table from '@material-ui/core/Table';
import { EEkycStatuses } from 'types/entities/users';

export const CellButtonsStyled = styled.div`
    display: inline-grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    gap: 1rem;
    justify-content: flex-start;
    width: 100px;
`;

export const CellButtonContentStyled = styled.span`
    display: grid;
    justify-content: center;
    align-items: center;
    grid-auto-flow: column;
    gap: 0.5rem;
    svg {
        width: 1rem;
    }
`;

export const TableStyled = styled(Table)``;

export const CellEkycStatusProcessing = styled.span`
    display: grid;
    grid-auto-flow: row;
    gap: 0.5rem;
    justify-content: flex-start;
`;

export const CellEkycStatus = styled.span<{ status: EEkycStatuses }>`
    ${({ status, theme }) => {
        switch (status) {
            case EEkycStatuses.VERIFIED:
                return css`
                    color: ${theme.branding.primary.main};
                `;
            case EEkycStatuses.UNVERIFIED:
                return css`
                    color: ${theme.branding.tertiary.main};
                `;
            case EEkycStatuses.PROCESSING:
                return css`
                    color: ${theme.branding.secondary.main};
                `;
        }
    }}
`;

export const CellRiskProfile = styled.span<{ score?: number }>`
    ${({ score, theme }) => {
        if (!score) {
            return css`
                color: ${theme.branding.secondary.dark};
            `
        }
        if (score <= 1) {
            return css`
                color: ${theme.branding.tertiary.main};
            `
        } else if (score > 2) {
            return css`
                color: ${theme.branding.primary.main};
            `
        } else {
            return css`
                color: ${theme.branding.quaternary.main};
            `
        }
    }}
`

export const Root = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: 1rem;
`;
